module.exports = __webpack_public_path__ + "static/img/wxtp_20260714114138_96_157.6ce9c3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/news/20260714/wxtp_20260714114138_96_157.jpg
// module id = GHuy
// module chunks = 0